'use client'

import { useState } from 'react'
import { BillCard } from '../BillCard'
import { Ticker } from 'motion-plus/react'

import { Bill, Topic } from '@/payload-types'
import { useLenisContext } from '@/providers/Lenis'

export const BillMarquee = ({ bills, topics }: { bills: Bill[]; topics: Topic[] }) => {
  const [isHovering, setIsHovering] = useState(false)
  const { windowDimensions } = useLenisContext()
  const { width } = windowDimensions

  const renderBillRows = (bills: Bill[]) => {
    //take modalities length and split it into 2 evenly distributed arrays
    const rows: Bill[][] = [[], []]
    rows[0] = bills.slice(0, bills.length / 2)
    rows[1] = bills.slice(bills.length / 2)
    return rows
  }
  const billsRows = renderBillRows(bills)
  const defaultVelocity = width ? (Number(width) >= 1024 ? 40 : 20) : 40
  return (
    <div className="relative z-10 w-full overflow-hidden">
      <div
        className=""
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {billsRows.map((billRow, index) => (
          <Ticker
            className="pb-6 lg:pb-8 [&_.bill-card]:max-sm:w-[calc(100vw-1rem)]"
            key={index}
            gap={32}
            velocity={isHovering ? 0 : index % 2 === 0 ? defaultVelocity : -defaultVelocity}
            hoverFactor={0}
            items={billRow.map((bill) => (
              <BillCard key={bill.id} bill={bill} allBillTopics={topics} />
            ))}
          />
        ))}
      </div>
    </div>
  )
}
